import React, { useState, useEffect, useContext, useRef } from 'react';
import classNames from "classnames";
import { makeStyles } from '@material-ui/core/styles';
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import {
  Select,
  MenuItem,
  TextField,
  FormControl,
  Modal,
  Typography,
  Chip,
  IconButton
} from '@material-ui/core';
import styles from "assets/jss/material-kit-react/views/landingPage.js";
import ProductSection from "./Sections/ProductSection.js";
import SectionDownload from "./Sections/SectionDownload.js";
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { language } from 'config';
import { FirebaseContext } from 'common';
import FaceIcon from '@material-ui/icons/Face';
import ControlPointIcon from '@material-ui/icons/ControlPoint';

const dashboardRoutes = [];

const useStyles = makeStyles(theme => ({
  ...styles,
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function LandingPage(props) {
  const { api } = useContext(FirebaseContext);
  const {
    addBooking,
    clearBooking,
    MinutesPassed
  } = api;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { ...rest } = props;
  const rootRef = useRef(null);
  const locationdata = useSelector(state => state.locationdata);
  const bookingdata = useSelector(state => state.bookingdata);
  const [pickupAddress, setPickupAddress] = useState(language.select_pickup);
  const [dropAddress, setDropAddress] = useState(language.select_drop);
  const auth = useSelector(state => state.auth);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [role, setRole] = useState(null);
  const [passengerModalStatus, setPassengerModalStatus] = useState(false);
  const [locations, setLocations] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedTime, setSelectedTime] = useState("00:00");
  const [coPassengers, setCoPassengers] = useState([]);
  const [textValue, setTextValue] = useState("");

  const getTime = () => {
    let arr = [];
    for (let i = 0; i <= 23; i++) {
      let hr = i.toString().length === 1 ? '0' + i.toString() : i.toString()
      for (let j = 0; j <= 45; j = j + 15) {
        let min = j.toString().length === 1 ? '0' + j.toString() : j.toString()
        arr.push(hr + ":" + min);
      }
    }
    return arr;
  }

  const timeList = getTime();

  useEffect(() => {
    if (auth.info && auth.info.profile) {
      setRole(auth.info.profile.usertype);
    }
  }, [auth.info]);

  useEffect(() => {
    if (locationdata.locations) {
      setLocations(locationdata.locations);
    } else {
      setLocations([]);
    }
  }, [locationdata.locations]);

  const handleGetOptions = (e) => {
    e.preventDefault();
    let selDateTime = new Date(selectedDate + "T" + selectedTime + ":00");
    if (auth.info) {
      if (pickupAddress && dropAddress && (pickupAddress !== dropAddress) && (pickupAddress !== language.select_pickup) && (dropAddress !== language.select_drop)) {
        if (MinutesPassed(selDateTime) >= 0) {
          setPassengerModalStatus(true);
        } else {
          setCommonAlert({ open: true, msg: language.past_booking_error })
        }
      } else {
        setCommonAlert({ open: true, msg: language.select_proper })
      }
    } else {
      setCommonAlert({ open: true, msg: language.must_login })
    }
  };

  const confirmBooking = (e) => {
    e.preventDefault();
    let bookingObject = {
      pickupAddress: pickupAddress,
      dropAddress: dropAddress,
      userDetails: auth.info,
      coPassengers: coPassengers,
      tripdate: new Date(selectedDate + "T" + selectedTime + ":00").toString()
    };
    dispatch(addBooking(bookingObject));
    setCoPassengers([]);
    setPassengerModalStatus(false);
  };

  const handlePassengerModalClose = (e) => {
    e.preventDefault();
    setCoPassengers([]);
    setPassengerModalStatus(false);
  };

  const handleBookingAlertClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    props.history.push('/bookings');
  };

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handlePickupChange = (event) => {
    setPickupAddress(event.target.value);
  };

  const handleDropChange = (event) => {
    setDropAddress(event.target.value);
  };

  const onDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleTimeSelect = (event) => {
    setSelectedTime(event.target.value);
  };

  const addNameToPassengers = () => {
    if (textValue) {
      if (coPassengers && coPassengers.length < 3) {
        let found = false;
        for (let i = 0; i < coPassengers.length; i++) {
          if (coPassengers[i] === textValue) {
            found = true;
            break;
          }
        }
        if (found) {
          setCommonAlert({ open: true, msg: language.duplicatePassenger });
        } else {
          let arr = [...coPassengers];
          arr.push(textValue);
          setCoPassengers(arr);
          setTextValue('');
        }
      } else {
        setTextValue('');
        setCommonAlert({ open: true, msg: language.maxPassengers });
      }
    } else {
      setCommonAlert({ open: true, msg: language.emptyPassenger });
    }
  }

  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/background.jpg")}>
        {!role || role === 'rider' ?
          <div className={classes.container}>
            <GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <br />
                <h1 className={classes.title}>{language.book_your_cab}</h1>
              </GridItem>
            </GridContainer>
            <GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <FormControl style={{ width: '100%' }}>
                  <Select
                    id="pickup-native"
                    value={pickupAddress}
                    onChange={handlePickupChange}
                    className={pickupAddress === language.select_pickup ? classes.inputdimmed : classes.input}
                  >
                    <MenuItem value={language.select_pickup} key={language.select_pickup}>
                      {language.select_pickup}
                    </MenuItem>
                    {
                      locations.map((location) =>
                        (dropAddress && dropAddress === location.locationName)?null:
                        <MenuItem key={location.locationName} value={location.locationName}>
                          {location.locationName}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            <GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <FormControl style={{ width: '100%' }}>
                  <Select
                    id="drop-native"
                    value={dropAddress}
                    onChange={handleDropChange}
                    className={dropAddress === language.select_drop ? classes.inputdimmed : classes.input}
                  >
                    <MenuItem value={language.select_drop} key={language.select_drop}>
                      {language.select_drop}
                    </MenuItem>
                    {
                      locations.map((location) =>
                        (pickupAddress && pickupAddress === location.locationName)?null:
                        <MenuItem key={location.locationName} value={location.locationName}>
                          {location.locationName}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            <GridContainer spacing={2}>
              <GridItem xs={8} sm={8} md={4} lg={4}>
                <TextField
                  id="datetime-local"
                  type="date"
                  fullWidth
                  value={selectedDate}
                  onChange={onDateChange}
                  className={classes.input}
                  InputProps={{ disableUnderline: true }}
                />
              </GridItem>
              <GridItem xs={4} sm={4} md={2} lg={2}>
                <Select
                  value={selectedTime}
                  onChange={handleTimeSelect}
                  fullWidth
                  className={classes.input}
                >
                  {
                    timeList.map((timeStr) =>
                      <MenuItem key={timeStr} value={timeStr}>
                        {timeStr}
                      </MenuItem>
                    )
                  }
                </Select>
              </GridItem>
            </GridContainer>
            <GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <Button
                  color="success"
                  size="lg"
                  rel="noopener noreferrer"
                  className={classes.items}
                  onClick={handleGetOptions}
                  style={{ height: 52 }}
                >
                  <i className="fas fa-car" />
                  {language.book_now}
                </Button>
              </GridItem>
            </GridContainer>
          </div>
          :
          <div className={classes.container}>
            <GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <br />
                <h1 className={classes.title}>{language.landing_slogan}</h1>
              </GridItem>
            </GridContainer>
          </div>
        }
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <ProductSection />
        </div>
      </div>
      <div className={classNames(classes.main2, classes.mainRaised2)}>
        <div className={classes.container}>
          <SectionDownload />
        </div>
      </div>
      <Footer />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={passengerModalStatus}
        onClose={handlePassengerModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
          <GridContainer spacing={1}>
            <GridItem xs={12}>
              <Typography xs={12} component="h1" variant="h5" style={{ marginBottom: 10 }}>
                {language.coPassengers}
              </Typography>
              {coPassengers.map((item) =>
                <Chip
                  style={{ marginRight: 5, marginBottom: 5 }}
                  icon={<FaceIcon />}
                  label={item}
                  onDelete={() => {
                    let arr = [...coPassengers];
                    arr.splice(arr.indexOf(item), 1);
                    setCoPassengers(arr);
                  }}
                  color="secondary"
                />
              )}
              <GridContainer>
                <GridItem xs={10}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="coPassenger"
                    label={language.coPassenger}
                    name="coPassenger"
                    autoComplete="coPassenger"
                    onChange={(e) => setTextValue(e.target.value)}
                    value={textValue}
                    autoFocus
                  />
                </GridItem>
                <GridItem xs={2} style={{marginTop:20}}>
                  <IconButton onClick={addNameToPassengers} color="primary" size='large'>
                    <ControlPointIcon />
                  </IconButton>
                </GridItem>
              </GridContainer>
            </GridItem>
            <GridItem xs={12}>
              <Button onClick={confirmBooking} variant="contained" color="success">
                {language.book_now}
              </Button>
              <Button onClick={handlePassengerModalClose} variant="contained" color="danger" style={{ marginLeft: 5 }}>
                {language.cancel}
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Modal>
      <AlertDialog open={bookingdata.booking ? true : false} onClose={handleBookingAlertClose}>{bookingdata.booking ? language.booking_success + bookingdata.booking.booking_id : null}</AlertDialog>
      <AlertDialog open={bookingdata.error.flag} onClose={handleBookingErrorClose}>{bookingdata.error.msg}</AlertDialog>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </div>
  );
}
